import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../../models/work-item';
import { UIMenuModel } from 'e5core-angular-services';

@Component({
  selector: 'e5core-ui-work-menu-box',
  templateUrl: './e5core-ui-work-menu-box.component.html',
  styleUrls: ['./e5core-ui-work-menu-box.component.css']
})
export class E5CoreUiWorkMenuBoxComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() menuItems: UIMenuModel[] ;

  constructor() { }

  ngOnInit() {
  }

}
